import React from 'react';
import { Link } from 'react-router-dom';
import { MessageSquare, ArrowRight } from 'lucide-react';

const getTheme = () => localStorage.getItem('theme') || 'light';

const NotFound = () => {
  const isDark = getTheme() === 'dark';

  return (
    <div className="auth-bg min-h-[100dvh] flex items-center justify-center p-4">
      <div className="w-full max-w-md text-center">
        <Link to="/welcome" className="inline-flex items-center gap-3 mb-10">
          <div className="w-12 h-12 rounded-2xl bg-ink flex items-center justify-center">
            <MessageSquare className="w-6 h-6 text-white" />
          </div>
          <span className="text-2xl font-bold gradient-text">هندل</span>
        </Link>

        <p className="text-7xl font-bold text-ink dark:text-white mb-3" style={{ fontFamily: '"Markazi Text", "Cairo", serif' }}>
          404
        </p>
        <h1 className={`text-xl font-bold mb-2 ${isDark ? 'text-white' : 'text-slate-900'}`}>
          الصفحة مش موجودة
        </h1>
        <p className={`mb-8 ${isDark ? 'text-slate-400' : 'text-slate-500'}`}>
          الرابط اللي فتحته مش موجود، أو اتنقل لمكان تاني.
        </p>

        <Link to="/welcome" className="btn-primary py-3 px-6 inline-flex">
          الرجوع للرئيسية
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
